export const AirportDelayMap = {
  bottom: {
    id: 'div-gpt-ad-1500406447041-0',
    sizes: [300, 250],
    adSlot: '/1010197/BS_AirportDelay_top_300x250',
  },
};
